import React, { useEffect, useState } from "react";
import { authFetch } from "../../api/api";


const BASE_URL = process.env.REACT_APP_DJANGO_BACKEND;

const EVENTS_API = `${BASE_URL}/api/events/`;


export default function OrderCalendarHistory({ orderId }) {

  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);


  useEffect(() => {

    const loadEvents = async () => {

      try {

        const res = await authFetch(EVENTS_API);

        const data = await res.json();


        const filtered = data
          .filter(
            (event) => event.order === Number(orderId)
          )
          .sort(
            (a,b) =>
              new Date(a.start_time) -
              new Date(b.start_time)
          );


        setEvents(filtered);


      } catch(error){

        console.error(
          "Ошибка загрузки истории:",
          error
        );

      } finally {

        setLoading(false);

      }

    };


    if(orderId){
      loadEvents();
    }


  }, [orderId]);



  if(loading){

    return (
      <div>
        Загрузка истории...
      </div>
    );

  }



  if(events.length === 0){

    return (
      <div className="text-gray-500">
        Нет событий
      </div>
    );

  }



  return (

    <div className="space-y-3">


      {events.map((event)=>(


        <div
          key={event.id}
          className="
            border
            rounded
            p-3
            text-sm
          "
        >


          <div className="font-semibold">

            {event.title}

          </div>



          <div className="text-gray-600">

            {new Date(
              event.start_time
            ).toLocaleString("ru-RU")}

          </div>



          {event.comments && (

            <div className="text-gray-500 mt-1">

              {event.comments}

            </div>

          )}



          <div
            className="mt-1"
          >

            Статус:

            {" "}

            {
              event.status === "done"
              ? "Выполнено"
              : "Не выполнено"
            }


          </div>


        </div>


      ))}


    </div>

  );


}